<template functional>
  <div style="align-content: center">
    <div
      v-if="
        props.row.approval_range_details &&
        props.row.approval_range_details.length
      "
    >
      <div
        v-for="(detail, index) in props.row.approval_range_details"
        :key="index"
      >
        <strong
          ><translate-text keyTranslate="shopping.range" /> {{ index + 1 }}:
        </strong>
        {{ detail.min_value }}
        {{ detail.min_operator }}
      </div>
    </div>
    <div v-else>
      <translate-text keyTranslate="shopping.no_approval_details" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'InitialValueColumn',
};
</script>
